import React from 'react';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

class Phototaker extends React.Component {
  constructor(props) {
    super(props);
    this.videoRef = React.createRef();
    this.canvasRef = React.createRef();
    this.state = {
      photos: [],
      error: null
    };
  }

  componentDidMount() {
    navigator.mediaDevices.getUserMedia({ video: true })
      .then(stream => {
        if (this.videoRef.current) {
          this.videoRef.current.srcObject = stream;
        }
      })
      .catch(err => {
        this.setState({ error: "Unable to access camera: " + err.message });
      });
  }

  componentWillUnmount() {
    if (this.videoRef.current && this.videoRef.current.srcObject) {
      this.videoRef.current.srcObject.getTracks().forEach(track => track.stop());
    }
  }

  takePhoto = () => {
    const { photos } = this.state;
    if (photos.length >= 3) return;

    const video = this.videoRef.current;
    const canvas = this.canvasRef.current;
    if (!video || !canvas) return;

    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

    const dataUrl = canvas.toDataURL('image/jpeg');
    this.setState({ photos: [...photos, dataUrl] });
  };

  resetPhotos = () => {
    this.setState({ photos: [] });
  };

  uploadPhotos = () => {
    if (this.props.photosTaken) {
      this.props.photosTaken(
        this.props.location_id,
        this.props.card_id,
        this.state.photos
      );
    }
  };

  render() {
    const { photos, error } = this.state;

    return (
      <div style={{ textAlign: 'center' }}>
        <Typography variant="h6" gutterBottom>
          Capture 3 Photos
        </Typography>

        {error && <Typography color="error">{error}</Typography>}

        <div style={{ position: 'relative', display: 'inline-block' }}>
          <video
            ref={this.videoRef}
            autoPlay
            playsInline
            style={{ width: '100%', maxWidth: '400px', border: '1px solid #ccc' }}
          />
          {/* Vertical egg-shaped face guide */}
          <div
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              width: '50%',
              height: '70%',          // taller than wide
              transform: 'translate(-50%, -50%)',
              border: '3px dashed rgba(255,255,255,0.7)',
              borderRadius: '50% / 60%', // makes ellipse vertical like an egg
              pointerEvents: 'none'
            }}
          />
        </div>

        <div style={{ marginTop: '1em' }}>
          <Button
            variant="contained"
            onClick={this.takePhoto}
            disabled={photos.length >= 3}
          >
            {photos.length < 3 ? `Capture (${photos.length}/3)` : 'Max 3'}
          </Button>
          {photos.length > 0 && (
            <>
              <Button
                style={{ marginLeft: '1em' }}
                variant="outlined"
                color="secondary"
                onClick={this.resetPhotos}
              >
                Reset
              </Button>
              {photos.length === 3 && (
                <Button
                  style={{ marginLeft: '1em' }}
                  variant="contained"
                  color="success"
                  onClick={this.uploadPhotos}
                >
                  Upload
                </Button>
              )}
            </>
          )}
        </div>

        <canvas ref={this.canvasRef} style={{ display: 'none' }} />

        {photos.length > 0 && (
          <div style={{ marginTop: '1em' }}>
            <Typography variant="subtitle1">Captured Photos:</Typography>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
              {photos.map((p, i) => (
                <img
                  key={i}
                  src={p}
                  alt={`Captured ${i + 1}`}
                  style={{
                    width: '120px',
                    height: '90px',
                    objectFit: 'cover',
                    border: '1px solid #ccc'
                  }}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default Phototaker;
